<template>
    <div class="qrcode" ref="qrCodeUrl">
        <div v-if="isuse"
            style="width:180px;height: 180px;position: absolute;background-color: rgba(0, 0, 0, .8);line-height: 180px; color: #fff;font-weight: 550;">
            已扫码</div>
        <div v-if="overdue"
            style="width:180px;height: 180px;position: absolute;background-color: rgba(0, 0, 0, .8);line-height: 180px; color: #fff;font-weight: 550;">
            已过期
            <div style="margin-top: -150px;color:#00E36B;">
                <span @click="rush_code">点击刷新</span>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from "qrcodejs2"
export default {
    name: 'codelogin',
    props: {
    },
    data() {
        return {
            isuse: false,
            overdue: false,
            qrcode1: "",
            times: null,
            link: ''
        }
    },
    created() {
        this.getwxqrcode()
    },
    methods: {
        rush_code() {
            location.reload()
        },
        async getwxqrcode() {
            // 获取appid
            let { data } = await this.$liveapi.getAppidByLogin()
            var id = data.data.authUrl + "/CodeView/CodeView.html?roomid=" + this.$route.params.id
            this.$liveapi.getwxqrcode(id + "&qrcode=").then(res => {
                this.link = res.data.data.code;
                this.creatQrCode();
                this.qrcode1 = this.link.slice(this.link.indexOf("&qrcode=") + 8, 99999999);
                this.times = setInterval(() => {
                    this.checkwxqrcode();
                }, 3000);
            });
        },
        creatQrCode() {
            var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: this.link, // 需要转换为二维码的内容
                width: 180,
                height: 180,
                colorDark: '#000000',
                colorLight: '#ffffff'
            })
        },
        stop_check() {
            clearInterval(this.times);
        },
        checkwxqrcode() {
            this.$liveapi.checkwxqrcode(this.qrcode1).then(res => {
                // 0 有效 1.失效 2.已扫码 3 扫码成功
                if (res.data.data.stats == 1) {
                    clearInterval(this.times);
                    this.overdue = true;
                }
                else if (res.data.data.stats == 2) {
                    this.isuse = true;
                }
                else if (res.data.data.stats == 3) {
                    clearInterval(this.times);
                    if (res.data.data.Data.block) {
                        this.$message({
                            message: "暂无访问权限",
                            type: "error"
                        });
                    }
                    else {
                        localStorage.setItem("user_name", res.data.data.Data.account);
                        localStorage.setItem("live_nick_name", res.data.data.Data.account);
                        if (!res.data.data.Data.avatar) {
                            localStorage.setItem('user_headimg',
                                'https://jingyu-resource.oss-cn-shanghai.aliyuncs.com/39/IMG/2024-08-14/vc-upload-1723601501374-131723602879982.png')
                        }
                        localStorage.setItem("user_headimg", res.data.data.Data.avatar);
                        localStorage.setItem("user_token_" + localStorage.getItem(this.$route.params.id + 'c_id'), res.data.data.Data.token);
                        var obj = {
                            enterpriseCode: localStorage.getItem('enterpriseCode'),
                            openId: res.data.data.Data.openId,
                            unionId: res.data.data.Data.unionId,
                            subjectType: res.data.data.Data.subjectType,
                        }
                        localStorage.setItem("bind_wxuser", JSON.stringify(obj));
                        localStorage.setItem("login_Type", "wx");
                        this.$message({
                            message: "登录成功",
                            type: "success"
                        })
                        localStorage.setItem("login_qd", 2)
                        setTimeout(() => {
                            window.location.reload()
                        }, 1000);
                    }
                }
                else {

                }
            });
        },
    },
    mounted() {
    },

}
</script>
<style scoped></style>
